module.exports = __webpack_public_path__ + "30d608cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_tag/Column/ic_right.png
// module id = 1265
// module chunks = 2